(function(angular, schoolwork12) {
	'use strict';
	
	schoolwork12.app.manageCourseManagement = {
        name: 'schoolwork12.courseManagement',
        controllers: {
            courseManagementSearch: 'courseManagementSearchCtrl',
            addCourse : 'addCourseCtrl',	
            editCourse : 'editCourseCtrl' 
        },
        routes: {
            courseManagement: '/course-management',
            addCourse: '/add-course',
            editCourse: '/edit-course'
        },
        templates : {
            courseManagementData: 'courseManagement/html/manageCourseManagement.html',
            addCourse : 'courseManagement/html/addCourse.html',
            editCourse : 'courseManagement/html/editCourse.html'
        },
        endpoints: {
            addCourse: schoolwork12.app.endpoint.concat('/course/savecourseDetails'),
            editCourse: schoolwork12.app.endpoint.concat('/course/savecourseDetails'),
            courseFilter: schoolwork12.app.endpoint.concat('/course/getFindCoursesDataForm/'),
            courseDropDownDetails: schoolwork12.app.endpoint.concat('/course/courseDropDownDetails/'),
            courseByCode: schoolwork12.app.endpoint.concat('/course/courseCode/'),
            nextCourseListByCode: schoolwork12.app.endpoint.concat('/course/nextCourseListByCode/'),
            reactivateCourses: schoolwork12.app.endpoint.concat('/course/reactivateCourses/'),
            deactivateCourses: schoolwork12.app.endpoint.concat('/course/deactivateCourses/'),
            searchCourses: schoolwork12.app.endpoint.concat('/course/coursesByCriteria/')
        },
        services: {
            courseManagementService: 'courseManagementSvc'
        },
        errorMessages: {
            invalidCreateDateFrom: "Invalid Create Date (From). Enter in MM/DD/YYYY format",
            invalidCreateDateTo: "Invalid Create Date (To). Enter in MM/DD/YYYY format.",
            courseCodeRequired: 'Course Code is required.',
            courseNameRequired: 'Course Name is required.',
            defaultCreditsRequired: 'Default Credits is required.',
            courseGradeRequired: 'Course Grade is required.',
            courseTypeRequired: 'Course Type is required.',
            daysPerWeekRequired: 'Days per Week is required for this course.',
            defaultAttendanceRequired: 'Default Attendance Minutes is required for this course.',
            maxNumberPrepDaysRequired: 'Max Number of Prep Days is required for this course.',
            coursePlatformRequired: 'Platform is required for this course.',
            contentProviderRequired: 'Content Provider is required for this course.',
            courseNameMaxLength: 'Course Name must not exceed 50 characters in length.',
            abbreviationMaxLength: 'Abbreviation must not exceed 20 characters in length.',
            daysPerWeekInvalidRange: 'Days per Week must be a number within the range of 1 to 7.',
            nextCourseInvalidValue: 'Next Course(s) must contain only valid course codes.',
            defaultAttendanceInvalidRange: 'Default Attendance Minutes must be a number within the range of 1 to 120.',
            maxNumberPrepInvalidValue: 'Max Number of Prep Days must be a number within the range of 0 to 21.',
            courseCodeDuplicated: 'Course Code is already in use by another course. Please enter a unique Course Code.',
            courseNameDuplicated: 'Course Name is already in use by another course. Please enter a unique Course Name.'
        }
	};
	
    angular.module(schoolwork12.app.manageCourseManagement.name, ['ui.grid', 'ui.grid.resizeColumns', 'ui.grid.selection',
    	'ui.grid.pagination','ui.grid.exporter', 'ui.bootstrap','ngTagsInput']);

}(angular, schoolwork12));
